import { Typography } from "@mui/material";
import { styled } from "@mui/system";

export const ExampleText = styled(Typography)(() => ({
  cursor: "pointer",
  transition: "all 0.2s",
  "&:hover": {
    color: "#7F56D9",
    transition: "all 0.2s",
  },
  marginLeft: "30px",
}));
